import styles from './/subscribe-success.module.css';
import { getCompanySlug, withAdminAuth } from '../../components/GetAuth';
import { Link } from "react-router-dom";

function SubscribeSuccess() {
  const companySlug = getCompanySlug();

  return (<div className={`${styles.MainDiv}`}>
    <div className={`${styles.PageTitleWrap}`}>
      <p className={`${styles.PageTitle}`}>Subscribe</p>
    </div>

    <div className={`${styles.successCard}`}>
      <p className={`${styles.successText}`}>Subscribed successfully!</p>
      <Link to={'/' + companySlug + '/booking/add-booking'} className={`${styles.bookingBtn}`}>Make a new booking</Link>
    </div>

  </div>);
}

export default withAdminAuth(SubscribeSuccess);